import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SCREENSHOTS = [
  { src: "/scrn-your-journey.png", caption: "My Journey" },
  { src: "/scrn-new-entry1.png", caption: "New Entry - Session Details" },
  { src: "/scrn-new-entry2.png", caption: "New Entry - Journal" },
  { src: "/scrn-entry-detail.png", caption: "Entry Detail" },
  { src: "/scrn-pattern-insights.png", caption: "Pattern Insights" },
  { src: "/scrn-pattern-insights2.png", caption: "Pattern Insights - By Strain" },
];

function Carousel({ current, setCurrent, onLightbox, isMobile }) {
  return (
    <div style={{ flexShrink: 0, width: isMobile ? "100%" : "340px" }}>
      <div
        onClick={() => onLightbox(current)}
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          border: "1px solid rgba(255,255,255,0.1)",
          boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
          cursor: "zoom-in"
        }}
      >
        <img
          src={SCREENSHOTS[current].src}
          alt={SCREENSHOTS[current].caption}
          style={{ width: "100%", display: "block" }}
        />
      </div>
      <div style={{ display: "flex", justifyContent: "center", gap: "8px", marginTop: "10px" }}>
        {SCREENSHOTS.map((_, i) => (
          <span
            key={i}
            onClick={() => setCurrent(i)}
            style={{
              width: "8px", height: "8px", borderRadius: "50%",
              background: i === current ? "#7dd3e8" : "rgba(255,255,255,0.3)",
              cursor: "pointer", display: "inline-block", transition: "background 0.3s"
            }}
          />
        ))}
      </div>
      <p style={{ textAlign: "center", fontSize: "12px", opacity: 0.5, marginTop: "6px" }}>
        {SCREENSHOTS[current].caption} — click to enlarge
      </p>
    </div>
  );
}

function WelcomePage() {
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  const [lightbox, setLightbox] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(c => (c + 1) % SCREENSHOTS.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const handleNext = () => {
    localStorage.setItem("hasSeenWelcome", "true");
    navigate("/login");
  };

  return (
    <main className="AuthPage" style={{ maxWidth: "860px" }}>

      {/* LIGHTBOX OVERLAY */}
      {lightbox !== null && (
        <div
          onClick={() => setLightbox(null)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.85)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            cursor: "zoom-out",
            padding: "24px"
          }}
        >
          <img
            src={SCREENSHOTS[lightbox].src}
            alt={SCREENSHOTS[lightbox].caption}
            style={{
              maxWidth: "90vw",
              maxHeight: "85vh",
              borderRadius: "12px",
              boxShadow: "0 16px 64px rgba(0,0,0,0.6)",
              display: "block"
            }}
          />
          <p style={{ color: "rgba(255,255,255,0.6)", fontSize: "13px", marginTop: "12px" }}>
            {SCREENSHOTS[lightbox].caption} — click anywhere to close
          </p>
        </div>
      )}

      <div style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        gap: isMobile ? "24px" : "48px",
        alignItems: "flex-start"
      }}>

        {/* SCREENSHOT — on mobile appears ABOVE text */}
        {isMobile && (
          <Carousel current={current} setCurrent={setCurrent} onLightbox={setLightbox} isMobile={true} />
        )}

        {/* TEXT */}
        <div style={{ flex: 1 }}>
          <p>The journey opens you. Journey Trails helps you hold what comes through.</p>

          {isMobile ? (
            <>
      <p>Journal cannabis sessions and psychedelic journeys, compare your intentions with your experience, check in with your chakras, map areas of awareness in your body, and tag each session with intention.</p>

<p>See what becomes clear over time. Notice which strains or types feel aligned with your intentions, which times of day your system tends to work well with, and what patterns begin to shift.</p>
    </>
  ) : (
    <>
      <p>Track cannabis sessions and psychedelic journeys, compare your intentions with your lived experience, check in with your chakras, map areas of awareness in your body, and tag each session with intention.</p>

<p>Over time, you’ll begin to see what becomes clearer — which strains or types of journeys feel most aligned with your intentions, which times of day your system tends to respond well to, and what patterns naturally shift.</p>
<p>Each session brings intention, emotion, body awareness, and subtle changes in your inner landscape. Journey Trails offers a grounded structure to capture what arises, stay connected to your experience, and return later to see what unfolded.</p>
<p>This is your space to enter each journey with intention and track how your experiences evolve. Your states, your patterns, your writing, and the shifts that accumulate across sessions all live here.</p>
<p>As you continue, you begin to see your own path more clearly:</p>
<ul>
<li>which strains or types feel most aligned with your intentions</li>
<li>which times of day your system tends to respond well</li>
<li>how your mood and sense of regulation move across journeys</li>
<li>what patterns repeat and what shifts over time</li>
</ul>
    </>
  )}

  <p><i><strong>Mindful journey mapping</strong></i></p>

          <div style={{ marginTop: "34px" }}>
            <button onClick={handleNext}>Next →</button>
          </div>
      </div>

        {/* SCREENSHOT — on desktop appears to the RIGHT of text */}
        {!isMobile && (
          <Carousel current={current} setCurrent={setCurrent} onLightbox={setLightbox} isMobile={false} />
        )}

      </div>
    </main>
  );
}

export default WelcomePage;